import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DownloadPage from './pages/DownloadPage';
import { printVersionInfo, checkVersionUpdate } from './version';

function App() {
  useEffect(() => {
    // 打印版本信息
    printVersionInfo();
    
    // 检查版本更新
    const hasUpdate = checkVersionUpdate();
    if (hasUpdate) {
      console.log('🎊 欢迎使用新版本！');
    }
  }, []);

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<DownloadPage />} />
        {/* 捕获所有未匹配的路径，重定向到首页 */}
        <Route path="*" element={<DownloadPage />} />
      </Routes>
    </Router>
  );
}

export default App;

